import Common from '../../Common';

interface Search {
	folder?: 'new' | 'old'
	search?: string
	limit?: number
	limit_from?: number
}

const Voicemail = class extends Common {
	browse = (mailboxUniqueId: string, search: Search = {}): CustomResponse<BrowseResponse & { voicemails: Voicemail[] }> =>
		this.get(`/mailbox/${mailboxUniqueId}/voicemail`, search)

	downloadMp3 = (mailboxUniqueId: string, voicemailId: id): CustomResponse<Blob> =>
		this.get(`/mailbox/${mailboxUniqueId}/voicemail/${voicemailId}/mp3`, {}, { responseType: 'blob' })

	delete = (mailboxUniqueId: string, voicemailId: string) =>
		this.doDelete(`/mailbox/${mailboxUniqueId}/voicemail/${voicemailId}`)
}

export default Voicemail
